import classNames from "classnames";
import { FC, useCallback } from "react";

import Modal from "components/Modal";

import { BaseOption } from "entities/common";
import { CreateReportPayload, REPORT_PERIOD_CUSTOM, ReportLevel } from "entities/reports";
import { useAppDispatch } from "store/hooks";
import { createReportRequest } from "store/slices/reportsSlice";

import GenerateReportContent, { ReportFormValues } from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  level?: ReportLevel;
  portfolio?: BaseOption;
  company?: BaseOption;
  asset?: BaseOption;
  isVisible: boolean;
  className?: string;
};

const WidgetModalGenerateReport: FC<PropTypes> = ({ isVisible, className, level, portfolio, company, asset }) => {
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(
    (values: ReportFormValues) => {
      const isCustom = values.period === REPORT_PERIOD_CUSTOM;
      const payload: CreateReportPayload = {
        name: values.name,
        level: values.level,
        company_id: values.companyId ? Number(values.companyId) : null,
        portfolio_id: Number(values.portfolioId),
        asset_id: values.level === "asset" && values.assetId ? Number(values.assetId) : null,
        period: values.period,
        start_date: isCustom && values.startDate ? values.startDate : null,
        end_date: isCustom && values.endDate ? values.endDate : null,
        export_format: values.format,
      };

      dispatch(createReportRequest(payload));
    },
    [dispatch],
  );

  return (
    <Modal
      title="Generate report"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <GenerateReportContent
        initialLevel={level}
        initialCompany={company ?? undefined}
        initialPortfolio={portfolio ?? undefined}
        initialAsset={asset ?? undefined}
        onSubmit={handleSubmit}
      />
    </Modal>
  );
};

export default WidgetModalGenerateReport;
